<style lang="scss" src='./CourseMap.scss' scoped></style>
<template src="./CourseMap.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations,
  } from 'vuex';

  import MapBlueFlag from '@/assets/img/ic/ic_flag_blue.png';
  import MapRedFlag from '@/assets/img/ic/ic_flag_red.png';
  import MapStation from '@/assets/img/ic/ico_marker_station.png';
  import SecurityComponent from '@/components/SecurityComponent.vue';
  import SensorDetails from '@/views/sensors/details/SensorDetails.vue';
  let validSensors = [];


  export default {
    name: 'Course',
    extends: SecurityComponent,
    components: {
      SensorDetails,
    },
    data() {
      return {
        google: {},
        map: {},
        markers: [],
        markersStation: [],
        sensorSelected: null,
      };
    },
    computed: {
      ...mapState('sensors', {
        sensor: (state) => state.sensor,
        rssiIcon: (state) => state.rssiIcon,
        pagination: (state) => state.pagination,
      }),
      ...mapState('Stations', {
        stations: (state) => state.stations,
      }),
      ...mapState(['course']),
      isCourseType(){
        if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
          || !this.course.facility_type){
            return true;
        }else{
          return false;
        }
      },
      sensors: {
        get() {
          return this.$store.state['sensors'].sensors
        },
        set(value) {
          this.setSensors(value)
        }
      },
    },
    methods: {
      ...mapActions('sensors', ['apiGetSensors']),
      ...mapActions('Stations', ['apiGetStations']),

      checkCourseType(){
        if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
          || !this.course.facility_type){
            return true;
        }else{
          return false;
        }
      },
      
      showSensorDetails(sensor) {
        this.sensorSelected = sensor;
        this.$bvModal.show('md-sensor-details');
      },

      async loadData() {
        await this.apiGetSensors();
        this.getValidSensors();
        await this.apiGetStations();
        this.sensorMap();
      },
      
      sensorMap() {
        if (validSensors.length > 0) {
          if (this.markers.length) {
            this.markers.forEach((m) => {
              m.setMap(null);
            });
          }
          let center = {
            lat: validSensors[0].lat,
            lng: validSensors[0].lng,
          };
          if (validSensors.length > 1) {
            const features = window.turf.featureCollection(
              validSensors.map((o) => window.turf.point([o.lat, o.lng])),
            );
            const gemetryCenter = window.turf.center(features);
            if (gemetryCenter.geometry && gemetryCenter.geometry.coordinates) {
              center = {
                lat: gemetryCenter.geometry.coordinates[0],
                lng: gemetryCenter.geometry.coordinates[1],
              };
            }
          }
          this.setMap(center, 21);
        } else {
          this.initMap();
        }
      },
      
      async initMap() {
        this.map = await this.G_initMap({
          mapId: 'courseMap',
          center: {
            lat: 0,
            lng: 0,
          },
          zoom: 2
        });
        this.google = this.consts.Google.MAP;
      },
      
      getRssiIcon(sensor) {
        // eslint-disable-next-line
        return require(`@/assets/img/sensor/${this.G_getRssiIcon(sensor, this.rssiRanges)}`);
      },

      setMap(center, zoom) {
        if (this.map && this.google && this.google.maps) {
          var latlngList = [];
          this.markers = validSensors.map((m) => {
            latlngList.push(new this.google.maps.LatLng(m.lat, m.lng));
            const infoWindow = new this.google.maps.InfoWindow({
              content: `
                <h5 class='d-flex align-items-center '> ${this.G_getSensorName({sensor: m, lbl: true, code: false})} <img src="${this.getRssiIcon(m)}" class='ic-sensor-signal'>  </h5>
                <table>
                <tr>
                <td class='text-right'>${this.$t('general.status')}: </td>
                <td class='text-left'>${m.status ? m.status.name : ''}</td>
                </tr>
                <tr>
                <td class='text-right'>${this.$t('sensors.location')}: </td>
                <td class='text-left'> ${ this.checkCourseType() ? this.G_getSensorLocation({ sensor: m }) : this.G_getZoneName({ zone: m.hole })} </td>
                </tr>
                <tr>
                <td class='text-right'>${this.$t('weatherStation.serialNumber')}: </td>
                <td class='text-left'>${m.serial_number}</td>
                </tr>
                <tr>
                <td class='text-right'>${this.$t('sensors.imeiMeid')}: </td>
                <td class='text-left'>${m.imei}</td>
                </tr>
                <tr>
                <td class='text-right'>${this.$t('sensors.provisionDate')}: </td>
                <td class='text-left'>${this.G_formatDate({date: m.provision_date, pretty: true})}</td>
                </tr>
                </table>
                  `,
            });

            const newMark = new this.google.maps.Marker({
              infoWindow,
              sensorId: m.sensor_id,
              sensor: m,
              position: m,
              icon: m.status_id !== this.consts.SensorStatus.CHECK ? MapBlueFlag : MapRedFlag,
            });
            
            newMark.setMap(this.map);
            
            newMark.addListener('click', (e) => {
                this.showSensorDetails(newMark.sensor);
            });

            return newMark;
          });

          this.markersStation = this.stations.map((m) => {
            let dataPosition = {
              lat: m.latitude,
              lng: m.longitude,
            }
            latlngList.push(new this.google.maps.LatLng(dataPosition.lat, dataPosition.lng));
            const infoWindow = new this.google.maps.InfoWindow({
              content: `
              <h5 class='d-flex align-items-center '> ${m.name} </h5>
              <table>
                <tr>
                  <td class='text-right'>${this.$t('weatherStation.stations')}: </td>
                  <td class='text-left'>${m.device_sn}</td>
                </tr>
              </table>`,
            });

            const icon = {
              url: MapStation,
              scaledSize: new google.maps.Size(100, 75),
            }

            const newMark = new this.google.maps.Marker({
              infoWindow,
              stationId: m.station_id,
              position: dataPosition,
              icon,
            });
            newMark.setMap(this.map);
            newMark.addListener('click', () => {
               if(!newMark.open){
                  infoWindow.open(this.map, newMark);
                  newMark.open = true;
                } else {
                  infoWindow.close();
                  newMark.open = false;
                }
            });
            return newMark;
          });

          this.markers = this.markers.concat(this.markersStation);

          var bounds = new this.google.maps.LatLngBounds();
          latlngList.map((n) => {
            bounds.extend(n);
          });
          this.map.setCenter(bounds.getCenter());
          this.map.fitBounds(bounds);
          this.map.setZoom(this.map.getZoom() - 1);
          if (this.map.getZoom() > 21) {
            this.map.setZoom(21);
          }

        } else {
          setTimeout(() => {
            this.setMap(center, zoom);
          }, 10);
        }
      },

      onCloseSensorDetailsModal() {
        this.sensorSelected = null;
      },

      getValidSensors(){
        validSensors = [];

        if (this.sensors && this.sensors.length > 0) {
          let sensorsArray = this.sensors;

          for (var i = 0; i < sensorsArray.length; i++){
            if(sensorsArray[i].latitude != undefined && sensorsArray[i].latitude != null && 
              sensorsArray[i].longitude != undefined && sensorsArray[i].longitude != null && 
              !isNaN(sensorsArray[i].latitude) && !isNaN(sensorsArray[i].longitude)
            ){
              if(this.G_validateLatLong(sensorsArray[i].latitude, sensorsArray[i].longitude)){
                sensorsArray[i].lat = sensorsArray[i].latitude;
                sensorsArray[i].lng = sensorsArray[i].longitude;
                validSensors.push(sensorsArray[i]);
              }
            }
          }
        }
      },

    },
    async mounted() {
      if (process.env.VUE_APP_SENTRY_ENV == "production") {
        this.$analytics.setCurrentScreen("Web Course");
        this.$analytics.logEvent("web_course");
      }

      this.getValidSensors();
      this.initMap();
      this.$parent.$on('courseChange', (val) => {
        if (val) {
          this.loadData();
        }
      });
      this.loadData();
    },
  };

</script>